import { Flex, Grid, Icon, IconName, Typography, theme } from '@aloft/toolkit-sui';

export const FeatureGridLabelColumnHeader = () => {
  const labelColumnHeaderItems: { icon: IconName; label: string }[] = [
    { icon: 'mls-listing', label: 'MLS' },
    { icon: 'public-record', label: 'Public' },
    { icon: 'inspectifyReport', label: 'Inspection' },
    { icon: 'user-input', label: 'User Input' },
    { icon: 'file-xml', label: 'XML' },
    { icon: 'arrow-down-s', label: 'Selection' },
  ];

  return (
    <Grid
      width="100%"
      gridTemplateColumns="repeat(2, 1fr)"
      padding="12px"
      __dangerDoNotUseSx={{
        borderRight: `1px solid ${theme.colors.strokeDefault}`,
        borderTop: `1px solid ${theme.colors.strokeDefault}`,
        borderLeft: `1px solid ${theme.colors.strokeDefault}`,
      }}
    >
      {labelColumnHeaderItems.map(({ icon, label }) => (
        <Flex key={label} alignItems="center" gap="4px">
          <Icon icon={icon} color="textLight" />
          <Typography variant="body1" color="textLight">
            {label}
          </Typography>
        </Flex>
      ))}
    </Grid>
  );
};
